import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSyncExternalStore } from "react";
import {
  activityElapsedLabel,
  activityKindLabel,
  EMPTY_ACTIVITY,
  getActivityLog,
  getRealtimeStatus,
  getSyncEmitError,
  isActivityPending,
  subscribeActivity,
  subscribeRealtimeStatus,
  subscribeSyncEmitError,
} from "../services/waveSession";
import type { WaveRealtimeStatus } from "@vida/wave-core";

function realtimeLabel(status: WaveRealtimeStatus): string {
  switch (status) {
    case "online":
      return "Online";
    case "polling":
      return "Sync";
    default:
      return "Offline";
  }
}

export function WaveActivityPage() {
  const navigate = useNavigate();
  const [, setTick] = useState(0);
  const activity = useSyncExternalStore(
    subscribeActivity,
    getActivityLog,
    () => EMPTY_ACTIVITY,
  );
  const realtimeStatus = useSyncExternalStore(
    subscribeRealtimeStatus,
    getRealtimeStatus,
    () => "offline" as WaveRealtimeStatus,
  );
  const syncEmitError = useSyncExternalStore(
    subscribeSyncEmitError,
    getSyncEmitError,
    () => null,
  );

  const pending = activity.filter((item) => isActivityPending(item));

  useEffect(() => {
    if (pending.length === 0) return;
    const timer = window.setInterval(() => setTick((value) => value + 1), 1000);
    return () => window.clearInterval(timer);
  }, [pending.length]);

  return (
    <div className="wave-push-page">
      <header className="wave-push-header">
        <button type="button" className="link-btn" onClick={() => navigate(-1)}>
          ← Indietro
        </button>
        <h1>Attività</h1>
      </header>

      <section className="wave-push-section">
        <h2>In corso</h2>
        {pending.length === 0 ? (
          <p className="muted">Nessuna attività in corso.</p>
        ) : (
          <ul className="wave-activity-list">
            {pending.map((item) => (
              <li key={item.id}>
                <strong>{item.title}</strong>
                <span>{item.detail}</span>
                <div className="wave-activity-meta">
                  <span className="wave-activity-kind">{activityKindLabel(item.kind)}</span>
                  <span>{activityElapsedLabel(item)}</span>
                </div>
              </li>
            ))}
          </ul>
        )}
      </section>

      <section className="wave-push-section">
        <h2>Cronologia sessione</h2>
        {activity.length === 0 ? (
          <p className="muted">Nessuna attività in questa sessione.</p>
        ) : (
          <ul className="wave-activity-list">
            {activity.map((item) => (
              <li key={item.id}>
                <strong>{item.title}</strong>
                <span>{item.detail}</span>
                <div className="wave-activity-meta">
                  <span className="wave-activity-kind">{activityKindLabel(item.kind)}</span>
                  {item.completedAt ? (
                    <span>Durata {activityElapsedLabel(item)}</span>
                  ) : null}
                  <time dateTime={new Date(item.at).toISOString()}>
                    {new Date(item.at).toLocaleString("it-IT")}
                  </time>
                </div>
              </li>
            ))}
          </ul>
        )}
      </section>

      <section className="wave-push-section">
        <h2>Cloud</h2>
        <dl className="wave-push-dl">
          <div>
            <dt>Live</dt>
            <dd>{realtimeLabel(realtimeStatus)}</dd>
          </div>
        </dl>
        {syncEmitError && <p className="invite-feedback error">{syncEmitError}</p>}
      </section>
    </div>
  );
}
